import _ from "lodash";

export async function getFNCSNotificationData(groupId) {

    const users = await global.app.R.CUser.find({
        fieldPath: ['kpUser'],
        group: new global.ObjectID(groupId)
    })

    const controllerData = await global.app.R.Reallocation.find({
        query: {
            status: 'ongoing'
        },
        group: new global.ObjectID(groupId)
    })

    const beneficiaryData = await global.app.R.Reallocation.find({
        fieldPath: ['beneficiary.id'],
        query: {
            status: {$in: ['waitingPayment', 'rectification']}
        },
        group: new global.ObjectID(groupId)
    })

    const groupedByUser =  _.groupBy(beneficiaryData, 'beneficiary.id')


    return users.reduce((acc, cUser) => ({
        [cUser.kpUser]: {
            'm-R-reallocationRequest': groupedByUser[cUser.id] && groupedByUser[cUser.id].length,
            'm-R-reallocationValidation': !!controllerData.length && controllerData.length
        },
        ...acc
    }), {})
}
